import { useOperator, useSearch } from "@/hooks";
import { GetInvoicesCompaniesParams } from "@/redux/apis/company/types";

export const useGetInvoicesCompaniesParams = () => {
  const { providerCode } = useOperator();
  const [search, setSearch] = useSearch();

  const params: GetInvoicesCompaniesParams = {
    search: search ?? undefined,
    include_invoice_metadata: providerCode === "adelaide-chauffeur-company" ? undefined : "1",
  };

  return {
    params,
    search: params.search,
    setSearch,
  };
};